import React from 'react'
import './portfolio.css'
import PIMG1 from '../../assets/portfolio-photos/erp1.png'

const data = [
  {
    id: 1,
    image: PIMG1,
    title: 'ERP Solution For Small Enterprise',
    github: 'https://github.com/Moksedul/ERP1_PUB',
    demo: 'https://erp1.pythonanywhere.com/'
  },
]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Works</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {
          data.map(({id, image, title, github, demo}) => {
            return (
              <article key={id} className='portfolio__item'>
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className='btn' target='_blank' rel='noreferrer'>Github</a>
                <a href={demo} className='btn btn-primary' target='_blank' rel='noreferrer'>Live Demo</a>
              </div>
            </article>
            )

          })
        }


      </div>
    </section>
  )
}

export default Portfolio